import type { CreateOrganization, OrganizationSummary } from '@MP/shared/api/hooks/auth';

import { OrgItem } from '../types';

export class OrganizationItem implements OrgItem {
  organization: OrganizationSummary;
  department: string | undefined;
  constructor(organization: OrganizationSummary) {
    this.organization = organization;
  }

  get name() {
    return this.organization.name || '';
  }

  get address() {
    return this.organization.address || '';
  }

  get id() {
    if (this.department) {
      return this.organization.department !== this.department ? undefined : this.organization.id;
    } else {
      return this.organization.id;
    }
  }

  get hpid() {
    return this.organization.hpid;
  }

  setDepartment(department: string) {
    this.department = department;
  }

  equals(other: OrgItem) {
    return this.id === other.id && this.hpid === other.hpid;
  }

  isNew() {
    return false;
  }

  getRequest(): CreateOrganization {
    return {
      name: this.organization.name,
      department: this.department,
      address: this.organization.address,
      addressDetail: this.organization.addressDetail,
      addressZipCode: this.organization.addressZipCode,
      tel: this.organization.tel,
      hpid: this.organization.hpid,
      latitude: this.organization.latitude,
      longitude: this.organization.longitude,
    };
  }

  valid() {
    return true;
  }
}
